import { render, staticRenderFns } from "./MainPeopleAtCompanyList.vue?vue&type=template&id=09e1f661&"
import script from "./MainPeopleAtCompanyList.vue?vue&type=script&lang=js&"
export * from "./MainPeopleAtCompanyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports